<div class="search-results">
  <div
    class="container search-results-main-container"
    *ngIf="isLoading && !instrumentDriverPage"
  >
    <ng-container *ngFor="let i of [].constructor(searchParams.ps ?? 10)">
      <app-search-loading></app-search-loading>
      <div class="separator"></div>
    </ng-container>
  </div>
  <div
    class="container search-results-main-container table-loading-container"
    *ngIf="isLoading && instrumentDriverPage"
  >
    <div class="table-loading">
      <div class="table-loading-row first"></div>
      <ng-container *ngFor="let i of [].constructor(searchParams.ps ?? 10)">
        <div class="table-loading-row"></div>
      </ng-container>
    </div>
  </div>
  <div *ngIf="!isLoading && searchResult && searchResult.searchResultList && searchResult.searchResultList.length">
    <div class="container search-results-main-container" *ngIf="!tableModeAvailable">
      <ng-container *ngFor="let resultEntry of searchResult.searchResultList; index as i">
        <ng-container [ngSwitch]="resultEntry.resourceType">
          <app-search-generic *ngSwitchCase="'search-generic'" [searchResultEntry]="resultEntry"></app-search-generic>
          <app-search-entity *ngSwitchCase="'search-entity'" [searchResultEntry]="resultEntry"></app-search-entity>
          <app-search-message-box *ngIf="i === 0 && searchResult?.highlightedEntity" [searchResult]="searchResult"></app-search-message-box>
          <app-search-data-plugin
            *ngSwitchCase="'search-data-plugin'"
            [searchResultEntry]="resultEntry"
          ></app-search-data-plugin>
          <app-search-instrument-driver
            *ngSwitchCase="'search-instrument-driver'"
            [searchResultEntry]="resultEntry"
          ></app-search-instrument-driver>
          <div class="separator" *ngIf="resultEntry.resourceType !== 'search-entity'"></div>
        </ng-container>
      </ng-container>
    </div>

    <div
      class="container search-results-main-container search-results-table-view-container g-0"
      *ngIf="tableModeAvailable || instrumentDriverPage"
    >
      <div class="row">
        <div class="col">
          <ng-container [ngSwitch]="firstResourceType">
            <app-search-instrument-driver-table
              *ngSwitchCase="'search-instrument-driver'"
              [searchResult]="searchResult"
              [tableHeaders]="tableHeaders"
            ></app-search-instrument-driver-table>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<app-search-no-result
  *ngIf="searchResult"
  [searchResult]="searchResult"
  [searchParams]="searchParams"
></app-search-no-result>
